import { Component, Inject, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import { MusicsDataService } from '../../providers/Table/musicsData.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-tmdb-search',
  templateUrl: './tmdbSearch.component.html',
  styleUrls: ['./tmdbSearch.component.scss']
})
export class TmdbSearchComponent implements OnInit, AfterViewInit {

  tmdbResults: any[] = [];

  filteredTmdbResults: any[] = [];

  defaultRecords: any = 10;

  pageEvent: any;

  loading = false;

  dataOut = {
    startRow: 0,
    endRow: 0,
    cover: '',
    edit: false,
    year: '',
    album: '',
    media_type: ''
  };

  @ViewChild('searchInput') searchInput;

  constructor(private musicsDataService: MusicsDataService,
              private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer,
              @Inject(MAT_DIALOG_DATA) private dataIn,
              private dialogRef: MatDialogRef<any>) {
    iconRegistry.addSvgIcon('close', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/close.svg'));
  }

  ngOnInit() {
    this.dataOut.startRow = this.dataIn.startRow;
    this.dataOut.endRow = this.dataIn.endRow;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.searchInput.nativeElement.value = this.dataIn.search;
      this.tmdbSearchCover(this.dataIn.search);
    });
  }

  tmdbSearchCover(search) {
    this.tmdbResults = [];
    this.filteredTmdbResults = [];
    if (search && search.length > 0) {
      this.loading = true;
      this.musicsDataService.tmdbSearchCover(search)
        .then(res => {
          this.loading = false;
          this.tmdbResults = res;
          this.filteredTmdbResults = this.tmdbResults.slice(0, this.defaultRecords);
        })
        .catch(() => {
          this.loading = false;
          this.tmdbResults = [];
          this.filteredTmdbResults = [];
        });
    }
  }

  tmdbSearchCoverEnter(e, search) {
    e.preventDefault();
    this.tmdbSearchCover(search);
  }

  selectCover(url, year, title, mediaType: string) {
    this.dataOut.edit = true;
    this.dataOut.cover = url;
    this.dataOut.year = year;
    this.dataOut.album = title;
    this.dataOut.media_type = mediaType;
    this.dialogRef.close(this.dataOut);
  }

  onPaginateChange(data) {
    this.filteredTmdbResults = this.tmdbResults.slice(data.pageIndex * data.pageSize, (data.pageIndex + 1) * data.pageSize);
  }

}
